export default __webpack_public_path__ + "static/media/circle-arrow-top.e2121eba.svg";